import { parseAsArrayOf, parseAsString } from 'nuqs';

const arrayOfStrings = parseAsArrayOf(parseAsString);

export enum PackagingFilterKey {
  Site = 'sites',
  Period = 'timePeriods',
  Supplier = 'suppliers',
  ActivitiesImport = 'activitiesImport',
  Tag = 'tags',
}

export enum PackagingFilterColumn {
  Site = 'site',
  Period = 'period',
  Supplier = 'supplier',
  ActivitiesImport = 'activitiesImport',
  Tag = 'tag',
}

export enum PackagingFilterApiKey {
  Site = 'sites',
  Period = 'time_periods',
  Supplier = 'suppliers',
  ActivitiesImport = 'activity_imports',
  Tag = 'tags',
}

export const packagingFilters = {
  [PackagingFilterKey.Site]: {
    column: PackagingFilterColumn.Site,
    apiKey: PackagingFilterApiKey.Site,
    type: arrayOfStrings,
  },
  [PackagingFilterKey.Period]: {
    column: PackagingFilterColumn.Period,
    apiKey: PackagingFilterApiKey.Period,
    type: arrayOfStrings,
  },
  [PackagingFilterKey.Supplier]: {
    column: PackagingFilterColumn.Supplier,
    apiKey: PackagingFilterApiKey.Supplier,
    type: arrayOfStrings,
  },
  [PackagingFilterKey.ActivitiesImport]: {
    column: PackagingFilterColumn.ActivitiesImport,
    apiKey: PackagingFilterApiKey.ActivitiesImport,
    type: arrayOfStrings,
  },
  [PackagingFilterKey.Tag]: {
    column: PackagingFilterColumn.Tag,
    apiKey: PackagingFilterApiKey.Tag,
    type: arrayOfStrings,
  },
};

export type PackagingFilterOption = keyof typeof packagingFilters;

export const packagingFilterKeys = Object.keys(
  packagingFilters
) as PackagingFilterOption[];
